export enum CommentScopeType {
  Component = "component",
  Page = "page"
}
